<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    data() {
        return {
            searchValue: null,
            selectedUser: null,
        }
    },

    computed: mapGetters({
        company: 'company',
        options: 'users',
    }),

    mounted() {
        this.fetch()
    },

    methods: {
        search(val) {
            this.searchValue = val
            this.fetch()
        },

        fetch() {
            this.$store.dispatch('usersFetchList', {
                search: this.searchValue,
                nopaged: true,
            })
        },

        addUser() {
            this.$store
                .dispatch('companiesAddUser', this.selectedUser)
                .then(() => {
                    this.selectedUser = null
                })
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    label {{ $t('COMPANIES.ADD_USER') }}
    .row.mb-4
        .col-24.col-sm.col-lg-12.col-xl-10
            acrm-multi-select.mb-3.mb-sm-0(
                :options="options.data"
                :multiple="false"
                track-by="id"
                option-label="display_name"
                @search="search"
                v-model="selectedUser"
                :placeholder="$t('COMPANIES.ADD_USER_HINT')"
                )
        .col-24.col-sm-auto
            acrm-input-button(:disabled="selectedUser == null" block icon="add" @click="addUser") {{ $t('BASE.ADD') }}
    acrm-setting-list-table(
        v-if="company && company.users && company.users[0]"
        :label="$t('COMPANIES.ADDED_USERS')"
        :data-array="company.users"
        :attributes="['display_name','email', 'balance', 'type']"
        indexed
        :translation="['USERS.NAME', 'USERS.EMAIL', 'USERS.BALANCE', 'USERS.TYPE']"
        :bold="['display_name']"
        del-function="companiesDelUser")
</template>
